export default __webpack_public_path__ + "static/media/walk.7b014a6e.svg";